import Select from "react-select";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import { mainUrl } from "API/client/api";
import axios from "axios";
import Layout from "layout";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button } from "react-bootstrap";

const SeoUpdate = () => {
    const { access_token } = useSelector(authenticationSeletor);

    // ---------------------- STATES ----------------------
    const [activeTab, setActiveTab] = useState("city");

    // CITY DROPDOWN
    const [allCities, setAllCities] = useState([]);
    const [selectCity, setSelectCity] = useState("");

    // LOCALITY DROPDOWN
    const [allLocalities, setAllLocalities] = useState([]);
    const [selectLocality, setSelectLocality] = useState("");

    // PROPERTY DROPDOWN
    const [allProperties, setAllProperties] = useState([]);
    const [selectProperty, setSelectProperty] = useState("");

    // SELECTED DATA (API response)
    const [selectedData, setSelectedData] = useState({});

    // BLOG ADD MODAL
    const [showBlogModal, setShowBlogModal] = useState(false);
    const [blogList, setBlogList] = useState([]);
    const [showViewModal, setShowViewModal] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [editId, setEditId] = useState(null);
    const [showImgModal, setShowImgModal] = useState(false);
    const [imgSrc, setImgSrc] = useState("");
    const [preview, setPreview] = useState(null);
    const [blogForm, setBlogForm] = useState({
        blogHeading: "",
        blogTitle: "",
        blogContent: "",
        keyword: "",
        metaTitle: "",
        metaDescription: "",
        metaContent: "",
        blogImg: null,
        imgAlt: "",
        imgTitle: ""
    });

    // CITY / LOCALITY / PROPERTY FORMS
    const [cityForm, setCityForm] = useState({ metaTitle: "", metaDesc: "", keywords: "", content: "" });
    const [localityForm, setLocalityForm] = useState({ metaTitle: "", metaDesc: "", keywords: "", content: "" });
    const [propertyForm, setPropertyForm] = useState({ metaTitle: "", metaDesc: "", keywords: "", content: "" });

    // ---------------------- FORM SELECTOR ----------------------
    const currentForm = activeTab == "city" ? cityForm : activeTab == "locality" ? localityForm : propertyForm;

    const setCurrentForm = (data) => {
        if (activeTab == "city") setCityForm(data);
        if (activeTab == "locality") setLocalityForm(data);
        if (activeTab == "property") setPropertyForm(data);
    };

    // ---------------------- GET ALL CITIES ----------------------
    const getAllCities = async () => {
        try {
            const cities = await axios.get(`${mainUrl}api/country/city`);
            if (cities?.status == 200) { setAllCities(cities.data.data.map(x => ({ value: x.id, label: x.name }))); }
        } catch (error) { console.log("Get All Cities Error:", error) }
    };

    // ------------------------ GET ALL Locality ------------------------
    const getAllLocalities = async () => {
        try {
            const localities = await axios.get(`${mainUrl}api/country/locality`);
            if (localities?.status == 200) { setAllLocalities(localities.data.data.map(x => ({ value: x.id, label: x.name }))); }
        } catch (error) { console.log("Get All Cities Error:", error) }
    };

    // ------------------------ GET ALL Properties ------------------------
    const getAllProperties = async () => {
        try {
            const properties = await axios.get(`${mainUrl}api/rrooms-property/property`);
            if (properties?.status == 200) { setAllProperties(properties.data.data.map(x => ({ value: x.id, label: x.name }))); }
        } catch (error) { console.log("Get All Cities Error:", error) }
    };

    // ------------------------ GET ALL Blog ------------------------
    const getAllBlogs = async () => {
        try {
            const res = await axios.get(`${mainUrl}api/blog/get-all-blog`);
            if (res?.data?.status) { setBlogList(res.data.data) }
        } catch (err) { console.log("Get Blogs Error", err) }
    };

    // ---------------------- GET LOCALITIES BY CITY ----------------------
    const getLocalitiesByCity = async (localityId) => {
        try {
            const res = await axios.get(`${mainUrl}api/locality/city/${localityId}`);
            if (res?.status == 200) { setAllLocalities(res.data.data.map(x => ({ value: x.id, label: x.name }))); }
        } catch (error) { console.log("Locality Error:", error) }
    };

    // ---------------------- GET PROPERTIES ----------------------
    const getPropertiesByCity = async (propertyId) => {
        try {
            const res = await axios.get(`${mainUrl}api/rrooms-property/property/${propertyId}`);
            if (res?.status == 200) { setAllProperties(res.data.data.map(x => ({ value: x.id, label: x.name }))); }
        } catch (error) { console.log("Property by City Error:", error) }
    };

    const getPropertiesByLocality = async (localityId) => {
        try {
            const res = await axios.get(`${mainUrl}api/property/by-locality/${localityId}`);
            if (res?.status == 200) { setAllProperties(res.data.data.map(x => ({ value: x.id, label: x.name }))); }
        } catch (error) { console.log("Property by Locality Error:", error) }
    };

    // ---------------------- GET SELECTED SEO DATA ----------------------
    const getSelectedSeo = async (id, type) => {
        if (!id) return;
        let url =
            type == "city"
                ? `${mainUrl}api/country/city/${id}`
                : type == "locality"
                    ? `${mainUrl}api/country/locality/${id}`
                    : `${mainUrl}api/rrooms-property/property/${id}`;
        try {
            const res = await axios.get(url);
            if (res?.status == 200) {
                const d = res.data.data;
                // setSelectedData(d);
                setCurrentForm(() => ({
                    metaTitle: d.metaTitle || "",
                    metaDesc: d.metaDescription || "",
                    keywords: d.keyword || "",
                    content: d.metaContent || ""
                }));
            }
        } catch (error) { console.log("SEO Fetch Error:", error) }
    };

    // ---------------------- DROPDOWN EFFECTS ----------------------
    useEffect(() => {
        setSelectCity("");
        setSelectLocality("");
        setSelectProperty("");
        setAllLocalities([]);
        setAllProperties([]);
        setCityForm({ metaTitle: "", metaDesc: "", keywords: "", content: "" });
        setLocalityForm({ metaTitle: "", metaDesc: "", keywords: "", content: "" });
        setPropertyForm({ metaTitle: "", metaDesc: "", keywords: "", content: "" });
    }, [activeTab]);

    // 1) LOAD ALL CITIES ONCE
    useEffect(() => {
        if (activeTab == "city") { getAllCities(); }
        if (activeTab == "locality") { getAllLocalities(); }
        if (activeTab == "property") { getAllProperties(); }
    }, [activeTab]);

    // 2) WHEN CITY CHANGES
    useEffect(() => {
        if (!selectCity) return;
        setSelectLocality("");
        setSelectProperty("");
        setAllLocalities([]);
        setAllProperties([]);
        if (activeTab == "city") { getSelectedSeo(selectCity, "city"); }
        if (activeTab == "locality") { getLocalitiesByCity(selectLocality); }
        if (activeTab == "property") { getPropertiesByCity(selectProperty); }
    }, [selectCity, activeTab]);

    // 3) WHEN LOCALITY CHANGES
    useEffect(() => {
        if (!selectLocality) return;
        setSelectProperty("");
        setAllProperties([]);
        if (activeTab == "locality") { getSelectedSeo(selectLocality, "locality"); }
        if (activeTab == "property") { getPropertiesByLocality(selectLocality); }
    }, [selectLocality, activeTab]);

    // 4) LOAD ALL BLOG
    useEffect(() => { if (activeTab == "blog") getAllBlogs(); }, [activeTab]);

    // 4) WHEN PROPERTY CHANGES
    useEffect(() => {
        if (!selectProperty) return;
        if (activeTab == "property") { getSelectedSeo(selectProperty, "property"); }
    }, [selectProperty, activeTab]);

    // ---------------------- FORM CHANGE ----------------------
    const handleFormChange = (e) => { setCurrentForm(prev => ({ ...prev, [e.target.name]: e.target.value })) };

    const handleContentChange = (value) => { setCurrentForm(prev => ({ ...prev, content: value })) };

    // ---------------------- QUILL TOOLBAR ----------------------
    const modules = {
        toolbar: [
            [{ font: [] }],
            [{ size: [] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "sub" }, { script: "super" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ align: [] }],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["link", "image", "video"],
            ["clean"],
        ],
    };

    const formats = [
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "script",
        "header",
        "align",
        "blockquote",
        "code-block",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "video",
    ];

    const updateCityData = async () => {
        try {
            const body = {
                metaTitle: cityForm.metaTitle,
                metaDescription: cityForm.metaDesc,
                keyword: cityForm.keywords,
                metaContent: cityForm.content
            };
            const headers = { "Content-Type": "application/json", Authorization: `Bearer ${access_token}` };
            const res = await axios.put(`${mainUrl}api/country/seo/update-city/${selectCity}`, body, { headers });
            if (res?.data?.status == true) {
                setSelectCity("")
                setCityForm({ metaTitle: "", metaDesc: "", keywords: "", content: "" });
            }
        } catch (error) { console.log("Error in update city data", error) }
    }

    const updateLocalityData = async () => {
        try {
            const body = {
                metaTitle: localityForm.metaTitle,
                metaDescription: localityForm.metaDesc,
                keyword: localityForm.keywords,
                metaContent: localityForm.content
            };
            const headers = { "Content-Type": "application/json", Authorization: `Bearer ${access_token}` };
            const res = await axios.put(`${mainUrl}api/country/seo/update-locality/${selectLocality}`, body, { headers });
            if (res?.data?.status == true) {
                setSelectLocality("")
                setLocalityForm({ metaTitle: "", metaDesc: "", keywords: "", content: "" });
            }
        } catch (error) { console.log("Error in update Locality Data", error) }
    }

    const updatePropertyData = async () => {
        try {
            const body = {
                metaTitle: propertyForm.metaTitle,
                metaDescription: propertyForm.metaDesc,
                keyword: propertyForm.keywords,
                metaContent: propertyForm.content
            };
            const headers = { "Content-Type": "application/json", Authorization: `Bearer ${access_token}` };
            const res = await axios.put(`${mainUrl}api/rrooms-property/seo/update/${selectProperty}`, body, { headers });
            if (res?.data?.status == true) {
                setSelectProperty("")
                setPropertyForm({ metaTitle: "", metaDesc: "", keywords: "", content: "" });
            }
        } catch (error) { console.log("Error in update Property Data", error) }
    }

    const viewBlog = (blog) => {
        setViewData(blog);
        setShowViewModal(true);
    };

    const handleBlogForm = (e) => {
        const { name, value, files } = e.target;
        if (files && files[0]) {
            const file = files[0];
            setPreview(URL.createObjectURL(file));
            setBlogForm((prev) => ({ ...prev, [name]: file }));
        } else {
            setBlogForm((prev) => ({ ...prev, [name]: value }));
        }
    };

    const addBlog = async () => {
        try {
            const formData = new FormData();
            formData.append("status", 1);
            Object.keys(blogForm).forEach(key => formData.append(key, blogForm[key]));
            const headers = { Authorization: `Bearer ${access_token}` };
            const res = await axios.post(`${mainUrl}api/blog/create-blog`, formData, { headers });
            if (res?.data?.status) { getAllBlogs(); setShowBlogModal(false) }
        } catch (err) { console.log("Add Blog Error:", err) }
    };

    const editBlog = async (id) => {
        try {
            setIsEdit(true);
            setEditId(id);
            setShowBlogModal(true);
            const res = await axios.get(`${mainUrl}api/blog/getblog/${id}`);
            if (res?.data?.status) {
                const d = res.data.data;
                setBlogForm({
                    blogHeading: d.blogHeading || "",
                    blogTitle: d.blogTitle || "",
                    blogContent: d.blogContent || "",
                    keyword: d.keyword || "",
                    metaTitle: d.metaTitle || "",
                    metaDescription: d.metaDescription || "",
                    metaContent: d.metaContent || "",
                    blogImg: d.blogImg || null,
                    imgAlt: d.imgAlt || "",
                    imgTitle: d.imgTitle || ""
                });
            }
        } catch (err) { console.log("Edit Blog Error:", err) }
    };

    const updateBlog = async () => {
        try {
            const formData = new FormData();
            Object.keys(blogForm).forEach(key => formData.append(key, blogForm[key]));
            const headers = { Authorization: `Bearer ${access_token}` };
            const res = await axios.put(`${mainUrl}api/blog/update-blog/${editId}`, formData, { headers });
            if (res?.data?.status) {
                getAllBlogs();
                setShowBlogModal(false);
                setIsEdit(false);
                setEditId(null);
            }
        } catch (err) { console.log("Update Blog Error:", err) }
    };

    const changeBlogStatus = async (id) => {
        try {
            const headers = { Authorization: `Bearer ${access_token}` };
            const res = await axios.put(`${mainUrl}api/blog/update-blog-status/${id}`, { status: 0 }, { headers });
            if (res?.data?.status) {
                getAllBlogs();
                setShowBlogModal(false);
                setIsEdit(false);
                setEditId(null);
            }
        } catch (err) { console.log("Update Blog Error:", err) }
    };

    const modalOverlay = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
    };

    const modalBox = {
        width: "800px", minWidth: "320px",
        background: "#fff",
        borderRadius: "12px",
        padding: "25px",
        boxShadow: "0 0 15px rgba(0,0,0,0.2)",
    };

    const modalInput = {
        width: "100%",
        padding: "5px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        // marginTop: "12px",
    };

    const isDisabled =
        !blogForm.blogHeading ||
        !blogForm.blogTitle ||
        !blogForm.blogContent ||
        !blogForm.keyword ||
        !blogForm.metaTitle ||
        !blogForm.metaDescription ||
        !blogForm.metaContent ||
        !blogForm.blogImg ||
        !blogForm.imgAlt ||
        !blogForm.imgTitle;

    return (
        <Layout>
            <div style={{ display: "flex", padding: "20px", gap: "20px" }}>
                <div style={{ width: "220px", background: "#fff", padding: "20px", borderRadius: "12px", boxShadow: "0 0 12px rgba(0,0,0,0.08)", height: "fit-content" }}>
                    {["city", "locality", "property", "blog"].map((tab) => (
                        <div key={tab} onClick={() => setActiveTab(tab)} style={{ padding: "12px", marginBottom: "10px", borderRadius: "8px", cursor: "pointer", background: activeTab == tab ? "#007bff" : "#f5f5f5", color: activeTab == tab ? "#fff" : "#333", textAlign: "center", fontWeight: "500" }}>{tab.toUpperCase()}</div>
                    ))}
                </div>
                {activeTab == "city" || activeTab == "locality" || activeTab == "property" ?
                    <div style={{ background: "#fff", padding: "25px", borderRadius: "12px", boxShadow: "0 0 12px rgba(0,0,0,0.08)", flex: 1 }}>
                        <h2 style={{ marginBottom: "20px", fontSize: "22px", fontWeight: "600" }}>Update {activeTab.toUpperCase()} SEO</h2>
                        {activeTab == "city" && (
                            <Select options={allCities} placeholder="Select City" value={allCities.find(o => o.value == selectCity) || null} onChange={(s) => setSelectCity(s?.value || "")} isSearchable />
                        )}
                        {activeTab == "locality" && (
                            <Select options={allLocalities} placeholder="Select Locality" value={allLocalities.find(o => o.value == selectLocality) || null} onChange={(s) => setSelectLocality(s?.value || "")} isSearchable />
                        )}
                        {activeTab == "property" && (
                            <Select options={allProperties} placeholder="Select Property" value={allProperties.find(o => o.value == selectProperty) || null} onChange={(s) => setSelectProperty(s?.value || "")} isSearchable />
                        )}
                        <div style={{ marginTop: 20 }}>
                            <input type="text" name="metaTitle" placeholder="Meta Title" value={currentForm.metaTitle} onChange={handleFormChange} style={inputStyle} />
                            <input type="text" name="keywords" placeholder="Meta Keywords" value={currentForm.keywords} onChange={handleFormChange} style={{ ...inputStyle, marginTop: 15 }} />
                            <textarea name="metaDesc" placeholder="Meta Description" value={currentForm.metaDesc} onChange={handleFormChange} style={{ width: "100%", marginTop: 15, padding: "12px", borderRadius: "8px", border: "1px solid #ccc", minHeight: "80px" }} />
                        </div>
                        <div style={{ marginTop: 25 }}>
                            <label style={{ marginBottom: "8px", display: "block", fontWeight: "500" }}>SEO Content</label>
                            <div style={{ height: "300px" }}>
                                <ReactQuill theme="snow" value={currentForm.content} onChange={handleContentChange} modules={modules} formats={formats} placeholder="Write SEO content..." style={{ height: "240px" }} />
                            </div>
                        </div>
                        <div>
                            {activeTab == "city" && (
                                <Button disabled={cityForm.metaTitle == ""} onClick={() => updateCityData()}>Update Content</Button>
                            )}
                            {activeTab == "locality" && (
                                <Button disabled={localityForm.metaTitle == ""} onClick={() => updateLocalityData()}>Update Content</Button>
                            )}
                            {activeTab == "property" && (
                                <Button disabled={propertyForm.metaTitle == ""} onClick={() => updatePropertyData()}>Update Content</Button>
                            )}
                        </div>
                    </div>
                    : ""}

                {activeTab == "blog" && (
                    <div style={{ background: "#fff", padding: "25px", borderRadius: "12px", boxShadow: "0 0 12px rgba(0,0,0,0.08)", flex: 1 }}>
                        <Button variant="primary" onClick={() => { setIsEdit(false); setEditId(null); setBlogForm({ blogHeading: "", blogTitle: "", blogContent: "", keyword: "", metaTitle: "", metaDescription: "", metaContent: "", blogImg: null }); setShowBlogModal(true) }}>
                            Add Blog
                        </Button>
                        <div style={{ marginTop: "20px", display: "flex", flexWrap: "wrap", gap: "15px" }}>
                            {blogList.map((blog) => (
                                <div
                                    key={blog.id}
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "12px",
                                        borderRadius: "8px",
                                        width: "48%",
                                        height: "175px",
                                        boxSizing: "border-box",
                                        display: "flex",
                                        gap: "12px"
                                    }}>
                                    <img
                                        src={`${mainUrl}${blog.blogImg}`}
                                        alt="Thumbnail"
                                        onClick={() => { setImgSrc(`${mainUrl}${blog.blogImg}`); setShowImgModal(true); }}
                                        style={{
                                            width: "130px",
                                            height: "100%",
                                            objectFit: "cover",
                                            cursor: "pointer",
                                            borderRadius: "8px",
                                            flexShrink: 0,
                                            boxShadow: "rgb(0 0 0 / 48%) 0px 5px 12px"
                                        }} />
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", width: "100%" }}>
                                        <div>
                                            <h6 style={{ margin: 0, textOverflow: "ellipsis", overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 1, WebkitBoxOrient: "vertical", marginBottom: "7px", color: "black" }}>{blog.blogHeading}</h6>
                                            <small style={{ margin: 0, textOverflow: "ellipsis", overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 1, WebkitBoxOrient: "vertical", color: "black", marginRight: "0px" }}>{blog.blogTitle}</small>
                                            <p style={{
                                                fontSize: "13px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                display: "-webkit-box",
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: "vertical",
                                                marginTop: "5px",
                                                marginRight: "5px"
                                            }}>
                                                {blog.blogContent}
                                            </p>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
                                            <Button size="sm" variant="info" onClick={() => viewBlog(blog)}>View</Button>
                                            <Button size="sm" onClick={() => editBlog(blog.id)}>Edit</Button>
                                            <Button size="sm" variant="danger" onClick={() => changeBlogStatus(blog.id)}>Delete</Button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {showBlogModal && (
                    <div style={modalOverlay}>
                        <div style={modalBox}>
                            <h3 style={{ marginBottom: "20px" }}>{isEdit ? "Edit Blog" : "Add New Blog"}</h3>
                            <div style={{ display: "flex", gap: "15px", marginTop: "12px" }}>
                                <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
                                    <label htmlFor="blogHeading" style={{ margin: "0px", color: "black" }}>Blog Heading</label>
                                    <input type="text" placeholder="Blog Heading" style={{ ...modalInput, width: "100%" }} name="blogHeading" value={blogForm.blogHeading} onChange={handleBlogForm} />
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
                                    <label htmlFor="blogTitle" style={{ margin: "0px", color: "black" }}>Blog Title</label>
                                    <input type="text" placeholder="Blog Title" style={{ ...modalInput, width: "100%" }} name="blogTitle" value={blogForm.blogTitle} onChange={handleBlogForm} />
                                </div>
                            </div>
                            <div style={{ display: "flex", gap: "15px", marginTop: "12px" }}>
                                <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                    <label htmlFor="blogContent" style={{ margin: "0px", color: "black" }}>Blog Content</label>
                                    <textarea placeholder="Blog Content" style={{ ...modalInput, height: "100px", minHeight: "60px" }} name="blogContent" rows={3} value={blogForm.blogContent} onChange={handleBlogForm} />
                                </div>
                            </div>
                            <div style={{ display: "flex", gap: "15px", marginTop: "12px" }}>
                                <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
                                    <label htmlFor="keyword" style={{ margin: "0px", color: "black" }}>Meta Keyword</label>
                                    <input type="text" placeholder="Meta Keyword" style={{ ...modalInput, width: "100%" }} name="keyword" value={blogForm.keyword} onChange={handleBlogForm} />
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
                                    <label htmlFor="metaTitle" style={{ margin: "0px", color: "black" }}>Meta Title</label>
                                    <input type="text" placeholder="Meta Title" style={{ ...modalInput, width: "100%" }} name="metaTitle" value={blogForm.metaTitle} onChange={handleBlogForm} />
                                </div>
                            </div>
                            <div style={{ display: "flex", gap: "15px", marginTop: "12px" }}>
                                <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
                                    <label htmlFor="metaDescription" style={{ margin: "0px", color: "black" }}>Meta Description</label>
                                    <textarea placeholder="Meta Description" id="metaDescription" style={{ ...modalInput, width: "100%", height: "80px", minHeight: "45px" }} name="metaDescription" rows={3} value={blogForm.metaDescription} onChange={handleBlogForm} />
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
                                    <label htmlFor="metaContent" style={{ margin: "0px", color: "black" }}>Meta Content</label>
                                    <textarea placeholder="Meta Content" id="metaContent" style={{ ...modalInput, width: "100%", height: "80px", minHeight: "45px", }} name="metaContent" rows={3} value={blogForm.metaContent} onChange={handleBlogForm} />
                                </div>
                            </div>
                            <div style={{ display: "flex", gap: "15px", marginTop: "12px" }}>
                                <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
                                    <label htmlFor="imgAlt" style={{ margin: "0px", color: "black" }}>Image Alt</label>
                                    <input type="text" id="imgAlt" placeholder="Image Alt" style={{ ...modalInput, width: "100%" }} name="imgAlt" value={blogForm.imgAlt} onChange={handleBlogForm} /></div>
                                <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
                                    <label htmlFor="imgTitle" style={{ margin: "0px", color: "black" }}>Image Title</label>
                                    <input type="text" id="imgTitle" placeholder="Image Title" style={{ ...modalInput, width: "100%" }} name="imgTitle" value={blogForm.imgTitle} onChange={handleBlogForm} /></div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "15px", marginTop: "15px", justifyContent: "center" }}>
                                {blogForm?.blogImg && (
                                    <img
                                        src={preview ? preview : `${mainUrl}${blogForm.blogImg}`}
                                        alt="Blog"
                                        style={{
                                            width: "50%",
                                            height: "150px",
                                            borderRadius: "8px",
                                            objectFit: "cover",
                                            border: "1px solid #ddd",
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => { setImgSrc(`${mainUrl}${blogForm.blogImg}`); setShowImgModal(true); }}
                                    />
                                )}
                                <label
                                    style={{
                                        width: "50%",
                                        height: "150px",
                                        border: "1px dashed #ccc",
                                        borderRadius: "8px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        background: "#f9f9f9",
                                        fontSize: "14px",
                                        color: "#555",
                                        textAlign: "center",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
                                    }}
                                >
                                    Upload
                                    <input type="file" name="blogImg" onChange={handleBlogForm} style={{ display: "none" }} />
                                </label>
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: "15px", }} >
                                <Button variant="secondary" onClick={() => { setShowBlogModal(false); setIsEdit(false); setEditId(null); }} >
                                    Cancel
                                </Button>
                                <Button variant="primary" disabled={isDisabled} onClick={() => (isEdit ? updateBlog() : addBlog())}>{isEdit ? "Update Blog" : "Save Blog"}</Button>
                            </div>
                        </div>

                    </div>
                )}

                {showViewModal && (
                    <div style={modalOverlay}>
                        <div style={{ ...modalBox, width: "750px", maxHeight: "90vh", overflowY: "auto", position: "relative", borderRadius: "12px", padding: "0", background: "#fff" }}>
                            <div
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    background: "#fff",
                                    padding: "15px 20px",
                                    borderBottom: "1px solid #ddd",
                                    borderTopLeftRadius: "12px",
                                    borderTopRightRadius: "12px",
                                    zIndex: 50
                                }}>
                                <h4 style={{ margin: 0 }}>View Blog</h4>
                            </div>
                            <div style={{ padding: "20px" }}>
                                {viewData?.blogImg && (
                                    <img src={`${mainUrl}${viewData.blogImg}`} alt="Blog" style={{ width: "100%", borderRadius: "8px", marginBottom: "15px", borderRadius: "8px", flexShrink: 0, boxShadow: "rgba(0, 0, 0, 0.30) 0px 5px 12px", height: "250px", objectFit: "cover", cursor: "pointer" }} onClick={() => { setImgSrc(`${mainUrl}${viewData.blogImg}`); setShowImgModal(true); }} />
                                )}
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <span style={{ margin: "0 0 10px 0", color: "black" }}><b>Image Alt:</b> {viewData?.imgAlt || "Image Alt"}</span>
                                    <span style={{ margin: "0 0 10px 0", color: "black" }}><b>Image Title:</b> {viewData?.imgTitle || "Image Title"}</span>
                                </div>
                                <h5 style={{ marginBottom: "15px", color: "black" }}><b>Heading:</b> {viewData?.blogHeading}</h5>
                                <h6 style={{ margin: "0 0 10px 0", color: "black" }}><b>Title:</b> {viewData?.blogTitle}</h6>
                                <p style={{ color: "black", marginBottom: "0px" }}><b>Content:</b></p>
                                <div style={{ background: "#f7f7f7", padding: "10px", borderRadius: "8px", marginBottom: "15px", color: "black" }}>
                                    {viewData?.blogContent}
                                </div>
                                <p style={{ color: "black" }}><b>Meta Keyword:</b> {viewData?.keyword}</p>
                                <p style={{ color: "black" }}><b>Meta Title:</b> {viewData?.metaTitle}</p>
                                <p style={{ color: "black", marginBottom: "0px" }}><b>Meta Description:</b></p>
                                <div style={{ background: "#f7f7f7", padding: "10px", borderRadius: "8px", marginBottom: "15px", color: "black" }}>
                                    {viewData?.metaDescription}
                                </div>
                                <p style={{ color: "black", marginBottom: "0px" }}><b>Meta Content:</b></p>
                                <div style={{ background: "#f7f7f7", padding: "10px", borderRadius: "8px", marginBottom: "15px", color: "black" }}>
                                    {viewData?.metaContent}
                                </div>
                            </div>
                            <div style={{ padding: "15px 20px", borderTop: "1px solid #ddd", background: "#fafafa", position: "sticky", bottom: 0, borderBottomLeftRadius: "12px", borderBottomRightRadius: "12px", textAlign: "right", zIndex: 50 }}>
                                <Button size="sm" variant="secondary" onClick={() => setShowViewModal(false)}> Close </Button>
                            </div>
                        </div>
                    </div>
                )}

                {showImgModal && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            background: "rgba(0,0,0,0.8)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 2000,
                        }}
                        onClick={() => setShowImgModal(false)}>
                        <img src={imgSrc} alt="Full Blog" style={{ width: "80vw", height: "80vh", borderRadius: "12px", objectFit: "contain", boxShadow: "0 4px 12px rgba(0,0,0,0.3)" }} />
                    </div>
                )}
            </div>
        </Layout>
    );
};

const inputStyle = { padding: "10px 12px", borderRadius: "8px", border: "1px solid #ccc", width: "100%" };

export default SeoUpdate;
